class Controller {
  constructor($injector, $stateParams, Sections) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.InvoiceItem = $injector.get("InvoiceItem");
    this.sections = Sections.plansSections;
    this.InvoiceItemTransforms = $injector.get("InvoiceItemTransforms");

    this.noteEvent = this.Events.getUpdateEvent("invoiceItemNote");
    this.cashCollectionStatus = $injector.get("Lists").all.cashCollectionStatus;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onAddNote = (options) => {
      const note = options.comment.value;

      this.InvoiceItem.addNote(this.$stateParams.id, { note }).$promise.then(
        (response) => {
          this.invoiceItem = this.InvoiceItemTransforms.justify(response);
          this.Events.emit(showNotificationEvent, {
            message: "Your note added successfully",
          });
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.InvoiceItem.get(this.$stateParams.id).$promise.then((response) => {
      this.invoiceItem = this.InvoiceItemTransforms.justify(response);
    });

    this.Events.on(this.noteEvent, onAddNote);
    this.resolveCashCollection = () => {
      const data = { ride_id: this.invoiceItem.ride };
      this.InvoiceItem.resolve(data)
        .$promise.then(() => {
          this.Events.emit(showNotificationEvent, {
            message: "Invoice Resolved Successfully",
          });
        })
        .catch((err) => {
          this.Events.emit(errorEvent, { message: err.data.message });
        });
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/invoiceItem/invoiceItem.controller.js